import { Skeleton, Stack } from '@mui/material';

const NAV_ITEM_COUNT = 7;

export const DashboardSidebarNavigationSkeleton = () => (
  <Stack sx={{ gap: 1.5, mt: 1, mx: 1 }}>
    {Array.from({ length: NAV_ITEM_COUNT }, (_, index) => (
      <Skeleton key={index} variant="rounded" height={32} />
    ))}
  </Stack>
);
